import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IBillingState, BillingActionCreators, IBillingListResponse, IApplicationState, AppActionCreators } from '@nkr/store/index';
import { ISortBy, IBillingDetail } from '@nkr/models/index';
import { Glyphicon, Table, FormControl, FormGroup } from 'react-bootstrap';
import SubmittedByRecipientCenterRow from './submitted-by-recipient-center-row';
import { TableWrapper } from '../styles';
import NoData from '../no-data';
import NavRecipientCenter from '../nav-recipient-center';
import { NavSubWrapper } from '../../styles';

interface IOwnProps {
    centerId: number,
    centerAlias: string,
    isRecipientCenter: boolean
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSubmittedByRecipientCenter: (centerId: number, isRecipientCenter: boolean) => Promise<IBillingListResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    list: IBillingDetail[],
    dateRange: number,
    sortBy: ISortBy,
    status: number
}

class SubmittedByRecipientCenter extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        sortBy: { property: 'transplantDate', direction: 'asc' },
        dateRange: 0,
        status: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            dateRange: parseInt(e.currentTarget.value)
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);

        if (sortBy.property == property) {
            if (sortBy.direction == 'asc') {
                sortBy.direction = 'desc'
            } else {
                if (sortBy.direction == 'desc') {
                    sortBy = { property: '', direction: '' };
                }
            }
        } else {
            sortBy = { property, direction: 'asc' };
        }

        this.setState({
            sortBy
        });
    }

    handleViewCharges = (donorId: number) => {
        window.location.href = `/center/${this.props.centerId}/billing/payment-view-edit/${donorId}`;
    }

    handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            status: parseInt(e.currentTarget.value)
        });
    }

    getData = () => {
        this.props.showLoading('Getting invoices, one moment please...').then(() => {
            this.props.getSubmittedByRecipientCenter(this.props.centerId, this.props.isRecipientCenter).then((response: IBillingListResponse) => {
                this.setState({
                    list: response.data.results
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    getFilteredRows = () => {
        return this.state.list.filter(x => {
            let dateRange = this.state.dateRange > 0 ? moment(x.billableNephrectomy.transplantDate).isAfter(moment().addDays(-1 * this.state.dateRange)) : true;

            return dateRange;
        });
    }

    getSortedRows = () => {
        let { property, direction } = this.state.sortBy;
        let filteredRows = this.getFilteredRows();
        let sortedRows: IBillingDetail[] = [];

        if (property != '') {
            sortedRows = _.orderBy(filteredRows, item => {
                switch (property) {
                    case 'transplantDate': return parseInt(moment(item.billableNephrectomy.transplantDate).format('YYYYMMDD'));
                    case 'swapNumber': return parseInt(item.billableNephrectomy.chainId + '' + item.billableNephrectomy.clusterNumber + '' + item.billableNephrectomy.positionNumber);
                    case 'donorCenter': return item.billableNephrectomy.donor.center.alias;
                    case 'donorAlias': return item.billableNephrectomy.donor.alias;
                    case 'recipientAlias': return item.billableNephrectomy.recipient.alias;
                    case 'recipientCenter': return item.billableNephrectomy.recipient.center.alias;
                    case 'claimType': return item.claimType;
                }

            }, [direction]);
        } else {
            sortedRows = filteredRows;
        }

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const rows = this.getSortedRows();

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 0px 5px' }}>
                    <NavSubWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                        <NavRecipientCenter
                            section={'PAYMENT-SUBMITTED-BY'}
                            tabText={''}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 5 }}>Filter by Date Range:</div>
                                    <div>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.dateRange}
                                            onChange={this.handleDateRangeChange}
                                        >
                                            <option value={0}>- Show All -</option>
                                            <option value={90}>Past 90 Days</option>
                                            <option value={120}>Past 120 Days</option>
                                            <option value={180}>Past 180 Days</option>
                                            <option value={365}>Past Year</option>
                                            <option value={730}>Past 2 Years</option>
                                        </FormControl>
                                    </div>
                                </div>
                            </FormGroup>
                        </div>
                    </NavSubWrapper>

                    {rows.length > 0 ?
                        <TableWrapper striped>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('transplantDate')}>TXP Date {this.renderHeaderSort('transplantDate')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('swapNumber')}>Swap #  {this.renderHeaderSort('swapNumber')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('donorCenter')}>Donor Center {this.renderHeaderSort('donorCenter')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('donorAlias')}>Donor Alias {this.renderHeaderSort('donorAlias')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('recipientCenter')}>Recipient Center {this.renderHeaderSort('recipientCenter')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('recipientAlias')}>Recipient Alias {this.renderHeaderSort('recipientAlias')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('claimType')}>Claim Type  {this.renderHeaderSort('claimType')}</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((item, index) =>
                                    <SubmittedByRecipientCenterRow
                                        key={index}
                                        data={item}
                                        isRecipientCenter={this.props.isRecipientCenter}
                                        onViewCharges={this.handleViewCharges}
                                    />
                                )}
                            </tbody>
                        </TableWrapper>
                        :
                        <NoData message='No payments submitted...' />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getSubmittedByRecipientCenter: (centerId, isRecipientCenter) => { return dispatch(BillingActionCreators.getSubmittedByRecipientCenter(centerId, isRecipientCenter)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SubmittedByRecipientCenter);